import { render, staticRenderFns } from "./Testtask.vue?vue&type=template&id=470d72bc&scoped=true"
import script from "./Testtask.vue?vue&type=script&lang=js"
export * from "./Testtask.vue?vue&type=script&lang=js"
import style0 from "./Testtask.vue?vue&type=style&index=0&id=470d72bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d72bc",
  null
  
)

/* custom blocks */
import block0 from "./Testtask.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports